<template>
    <span :class="{ 'text-[--el-color-primary]': value && value.length }" class="flex items-center">
        {{ props.label }}
        <el-popover placement="bottom-start" popper-class="dropClass" trigger="click" ref="popover">
            <template #reference>
                <icon-svg-search class="cursor-pointer text-[var(--text-color)] size-15PX hover:text-[--el-color-primary]" />
            </template>
            <el-input v-if="props.search" v-model="valueInput" :placeholder="props.placeholder || '请输入名称搜索过滤'" />
            <!-- 多选 -->
            <el-checkbox-group v-model="value" v-if="props.multiple">
                <el-checkbox v-for="item in optionsList" :key="item.value" :value="item.value">{{ item.text }}</el-checkbox>
            </el-checkbox-group>
            <!-- 单选 -->
            <ul class="el-table-filter__list radioBox" v-else>
                <template v-for="item in optionsList" :key="item.value">
                    <li
                        :class="['el-table-filter__list-item', item.value === value ? 'is-active' : '']"
                        @click="optionsClick(item)"
                        class="text-overflow"
                    >
                        {{ item.text }}
                    </li>
                </template>
            </ul>
            <el-button type="text" @click="handleConfirm()">Confirm</el-button>
            <el-button type="text" @click="handleReset()">Reset</el-button>
        </el-popover>
    </span>
</template>
<script setup lang="ts">
const props = defineProps<{
    // 选中的筛选值
    value: string | string[];
    // 文字显示
    label: string;
    // 选项
    options: { text: string; value: string }[];
    // 多选
    multiple?: boolean;
    // 是否需要手动查询过滤
    search?: boolean;
    placeholder?: string;
}>();
const emit = defineEmits<{
    (e: 'update:value', value: string): void;
    (e: 'update:options', options: string): void;
    (e: 'confirm'): void;
    (e: 'reset'): void;
    (e: 'optionsClick'): void;
}>();
const { value, options } = useVModels(props, emit);
const popover = ref();
// input输入框
const valueInput = ref();
// 多选项
const optionsList = computed(() => {
    return valueInput.value ? options.value.filter((item: any) => item.text.indexOf(valueInput.value) > -1) : options.value;
});
// 确认
const handleConfirm = () => {
    emit('confirm');
    popover.value.hide();
};
// 重置
const handleReset = () => {
    value.value = props.multiple ? [] : '';
    valueInput.value = '';
    emit('reset');
    popover.value.hide();
};
// 单选下拉项点击事件
const optionsClick = (item: any) => {
    value.value = item.value;
    emit('optionsClick');
    popover.value.hide();
};
</script>
<style lang="scss">
.el-checkbox-group {
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 300px;
    label {
        width: 100%;
    }
}
</style>
<style scoped lang="scss">
.radioBox {
    max-height: 300px;
    overflow-y: auto;
}
</style>
